import Image from 'next/image';
import Link from 'next/link';
export function WhatsappSupport() {
  const phoneNumber = '+919020123466';
  const prefilledMessage = 'Hi';
  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(prefilledMessage)}`;
  return <div className="mt-2 flex flex-col items-start self-stretch rounded-lg border bg-white px-3 py-5 shadow md:gap-2 md:border-none" data-sentry-component="WhatsappSupport" data-sentry-source-file="whatsapp-support.tsx">
      {/* Help Section */}
      <div className=" w-full text-start">
        <p className="text-sm font-normal">Have any doubts ?</p>
        <p className="font-semibold md:text-lg">Get answers fast!</p>
        <p className="font-semibold md:text-lg">Chat with our assistant for instant Help</p>
      </div>
      <Link href={whatsappLink} target="_blank" rel="noopener noreferrer" className="mt-4 flex h-10 w-full items-center justify-center gap-1.5 rounded-[7px] bg-[#0ECC56] px-4 text-white md:w-auto" data-sentry-element="Link" data-sentry-source-file="whatsapp-support.tsx">
        <Image src="/whatapp.svg" alt="WhatsApp" width={20} height={21} data-sentry-element="Image" data-sentry-source-file="whatsapp-support.tsx" />
        Chat on WhatsApp
      </Link>
    </div>;
}